import type { TimeOfDayPeriod } from './timeOfDayGradient';

import styles from './TimeOfDayGradientBackground.module.css';

const PERIODS: readonly TimeOfDayPeriod[] = ['morning', 'day', 'night'];

const LAYER_CLASS_NAME: Record<TimeOfDayPeriod, string> = {
  morning: styles.morning,
  day: styles.day,
  night: styles.night,
};

interface Props {
  period: TimeOfDayPeriod;
}

/**
 * Crossfades between the Morning/Day/Night gradients by stacking one layer
 * per period and animating `opacity` — most browsers can't animate between
 * two different `linear-gradient()` values directly. The consuming page
 * needs `position: relative` on `.page` for this to anchor to.
 */
export function TimeOfDayGradientBackground({ period }: Props) {
  return (
    <div aria-hidden="true" className={styles.background}>
      {PERIODS.map((candidate) => (
        <div
          key={candidate}
          className={`${styles.layer} ${LAYER_CLASS_NAME[candidate]}`}
          style={{ opacity: candidate === period ? 1 : 0 }}
        />
      ))}
    </div>
  );
}
